import React from "react";

function Hero() {
  return (
    <section className="hero">
      <div className="hero-overlay" />
      <div className="hero-content">
        <p className="hero-kicker">You are cordially invited to celebrate</p>
        <h1 className="hero-title">The Wedding of Aliya & Jayrell</h1>
        <p className="hero-subtitle">
          Saturday • September 19, 2026 • 4:00 PM
        </p>
        <p className="hero-location">
          Baltimore, Maryland
        </p>
      </div>
    </section>
  );
}

export default Hero;